import { DROPDOWN_HEIGHT } from "./Customers/customersConfig";

/**
 * MUI Select styles aligned with Create Ticket (TicketDropdowns / CreateTicket).
 */

export const peopleSelectMenuProps = {
  PaperProps: {
    sx: {
      border: "1px solid #D5DCE1",
      marginTop: "8px",
      borderRadius: "8px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      "& .MuiList-root": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        fontSize: "14px",
        fontFamily: "Inter",
        color: "#556575",
        borderRadius: "8px",
        padding: "0 8px !important",
        margin: "0 8px",
        height: "32px",
        minHeight: "32px !important",
        fontWeight: 400,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        lineHeight: "32px",
        boxSizing: "border-box",
        "& + .MuiMenuItem-root": {
          marginTop: "4px",
        },
        "&:hover": {
          color: "#061522",
          background: "#F9FAFA",
        },
        "&.Mui-selected": {
          backgroundColor: "#F9FAFA",
          color: "#061522",
          "&:hover": {
            backgroundColor: "#F9FAFA",
          },
        },
      },
    },
  },
};

/** Scrollable select menu (224px max height, opens downward). */
export function peopleScrollSelectMenuProps() {
  return {
    ...peopleSelectMenuProps,
    disableScrollLock: true,
    PaperProps: {
      ...peopleSelectMenuProps.PaperProps,
      sx: {
        ...peopleSelectMenuProps.PaperProps.sx,
        maxHeight: DROPDOWN_HEIGHT,
        overflow: "hidden",
        boxSizing: "border-box",
      },
    },
    MenuListProps: {
      sx: {
        maxHeight: DROPDOWN_HEIGHT - 16,
        overflowY: "auto",
        overflowX: "hidden",
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(0,0,0,0.2) transparent",
        padding: "4px 0",
      },
    },
  };
}

/** Extra sx for the Select element (font/color). */
export const peopleSelectSx = {
  fontSize: "14px",
  color: "#405261",
  fontFamily: "Inter",
};

const selectIconSx = {
  "& .MuiSelect-icon": {
    fontSize: "16px",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 16,
    height: 16,
    pointerEvents: "none",
  },
  "& .MuiSelect-iconOpen": {
    fontSize: "16px",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%) rotate(180deg)",
    right: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 16,
    height: 16,
    pointerEvents: "none",
  },
};

/**
 * FormControl sx for People section selects.
 * @param {{ width?: number|string, minWidth?: number|string, maxWidth?: number|string, height?: number, flexShrink?: number }} opts
 */
export function peopleSelectControlSx(opts = {}) {
  const height = opts.height ?? 40;
  return {
    ...(opts.width !== undefined && { width: opts.width }),
    ...(opts.minWidth !== undefined && { minWidth: opts.minWidth }),
    ...(opts.maxWidth !== undefined && { maxWidth: opts.maxWidth }),
    ...(opts.flexShrink !== undefined && { flexShrink: opts.flexShrink }),
    borderRadius: "8px",
    background: "#FFF",
    boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
    fontFamily: "Inter",
    fontSize: 14,
    height,
    color: "#405261",
    "& .MuiOutlinedInput-notchedOutline": { border: "1px solid #D5DCE1" },
    "&:hover .MuiOutlinedInput-notchedOutline": { border: "1px solid #D5DCE1" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "1px solid #D5DCE1" },
    "& .MuiOutlinedInput-root": {
      height,
      borderRadius: "8px",
    },
    "& .MuiSelect-select": {
      padding: "0px 36px 0px 16px !important",
      display: "flex",
      alignItems: "center",
      height,
      minHeight: "unset !important",
      boxSizing: "border-box",
      fontSize: 14,
      lineHeight: 1.2,
      color: "#405261",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0px 16px !important",
    },
    ...selectIconSx,
  };
}
